export const INTERVIEW_STATUS = {
  // 待评估
  PENDING: 1,
  // 已预约
  SCHEDULED: 2,
  // 已评估
  FINISHED: 3,
  // 被组织者取消
  CANCELED_BY_ORGANIZER: 4,
  // 部分评估
  PARTIALLY_RATED: 5,

  // 待候选人选择时间
  PENDING_CANDIDATE_SELECT_TIME: 6,
  // 待HM选择时间
  PENDING_HM_SELECT_TIME: 7,

  // 候选人重新预约
  RESCHEDULING_BY_CANDIDATE: 8,
  // 面试官重新预约
  RESCHEDULING_BY_INTERVIEWER: 9,

  // 被候选人取消
  CANCELED_BY_CANDIDATE: 10,
  // 被面试官取消
  CANCELED_BY_INTERVIEWER: 11,
  // 待生成Teams链接
  PENDING_GENERATE_TEAMS_URL: 12,
  // 被部分面试官取消
  PARTIAL_CANCELED_BY_INTERVIEWER: 13,
  // 待生成Teams事件
  PENDING_GENERATE_TEAMS_EVENT: 14
}

export const INTERVIEW_CANCELED_STATUS = [
  INTERVIEW_STATUS.CANCELED_BY_CANDIDATE,
  INTERVIEW_STATUS.CANCELED_BY_INTERVIEWER,
  INTERVIEW_STATUS.CANCELED_BY_ORGANIZER
]

export const LIST_TYPE = {
  TABLE: 'TABLE',
  CALENDAR: 'CALENDAR'
}

export const RATE_STATUS = {
  NOT_RECOMMENDED: 0,
  PENDING: 1,
  RECOMMENDED: 2,
  NO_RECOMMENDATION: 3
}

export const INTERVIEW_RATING_DECISION = {
  NOT_RATE_YET: 'NOT_RATE_YET',
  PENDING: 'PENDING',
  CONFLICT: 'CONFLICT',
  RECOMMENDED: 'RECOMMENDED',
  NOT_RECOMMENDED: 'NOT_RECOMMENDED',
  NO_RECOMMENDATION: 'NO_RECOMMENDATION'
}

export const RATE_STATUS_MAP = {
  [RATE_STATUS.NOT_RECOMMENDED]: INTERVIEW_RATING_DECISION.NOT_RECOMMENDED,
  [RATE_STATUS.PENDING]: INTERVIEW_RATING_DECISION.PENDING,
  [RATE_STATUS.RECOMMENDED]: INTERVIEW_RATING_DECISION.RECOMMENDED,
  [RATE_STATUS.NO_RECOMMENDATION]: INTERVIEW_RATING_DECISION.NO_RECOMMENDATION
}

export const RATE_OPERATE_STATUS = {
  PENDING: `${RATE_STATUS.PENDING},${RATE_STATUS.NO_RECOMMENDATION}`,
  FINISHED: `${RATE_STATUS.NOT_RECOMMENDED},${RATE_STATUS.RECOMMENDED}`
}

export const AI_INTERVIEW_STATUS = {
  WAITING: 1,
  CANCELED: 2,
  PENDING: 3,
  FINISHED: 4,
  TIMEOUT: 5
}

export const AI_INTERVIEW_QUESTION_TYPE = {
  VIDEO: 1,
  AUDIO: 2,
  SINGLE: 3,
  MULTI: 4,
  SINGLE_LINE: 5,
  MULTI_LINE: 6,
  GAME: 7,
  NUMBER: 8,
  LOCATION_MAP: 9,
  DATE: 10,
  REGION: 11,
  SORT: 12,
  FILE_UPLOAD: 13,
  ROLL_AXIS: 14,
  MOVEMENT_DETECTION: 15,
  HAND_DETECTION: 16,
  IMAGE_QUALITY: 17,
  SIGN: 18,
  AI_MODEL: 19,
  GLOBAL_INTENTION_STORE: 20,
  HEIGHT_DETECTION_V2: 21,
  HAND_DETECTION_V2: 22,
  PPT: 23,
  FIND_TRICK: 25,
  CONVERSATION: 26
}

export const DEFAULT_TIME_ZONE = '101'

export const INTERVIEW_OPERATION_TYPE = {
  CONFIRM_TIME: 0,
  REJECT: 1,
  SUGGEST_NEW_TIME: 2,
  CANCEL: 3,
  HM_SELECT_TIME: 4
}

export const INTERVIEW_TIME_TYPE = {
  AUTOMATIC: 'AUTOMATIC'
}

export const HM_INTERVIEW_SOURCE_TYPE = {
  LEGACY: 'legacy',
  NEW_QUESTIONNAIRE: 'new_questionnaire',
  NEW_MANUAL: 'new_manual'
}

export const NEW_RUNTIME_SOURCE_TYPES = [
  HM_INTERVIEW_SOURCE_TYPE.NEW_QUESTIONNAIRE,
  HM_INTERVIEW_SOURCE_TYPE.NEW_MANUAL
]

export const INTERVIEW_TYPE_F2F = 'f2f'
export const INTERVIEW_TYPE_ONLINE = 'online'
export const INTERVIEW_TYPE_ONLINE_TEAMS_MEETING = 'online_teams_meeting'
export const INTERVIEW_TYPE_ONLINE_ZOOM_MEETING = 'online_zoom_meeting'
export const INTERVIEW_TYPE_TELEPHONE = 'telephone'
export const INTERVIEW_TYPE = [
  INTERVIEW_TYPE_F2F,
  INTERVIEW_TYPE_ONLINE,
  INTERVIEW_TYPE_ONLINE_TEAMS_MEETING,
  INTERVIEW_TYPE_ONLINE_ZOOM_MEETING,
  INTERVIEW_TYPE_TELEPHONE
]
